module.exports = __webpack_public_path__ + "static/media/handoff-thanks.6c6f720d.png";